module.exports = __webpack_public_path__ + "static/media/photo7@2x.48cc492d.jpg";